import { useState } from 'react';
import { t } from '../i18n';
import { userMessage } from '../i18n/errors';
import './DeleteConfirmation.css';

/**
 * Deleting a record asks first (T117, FR-029, spec.md Story 7 Acceptance 5): the first tap shows
 * what will be deleted, and only "Supprimer définitivement" deletes it. A refusal (for example a
 * stock that would go below zero) is shown in place.
 */
export function DeleteConfirmation({
  label,
  warning,
  onConfirm,
}: {
  label: string;
  warning: string;
  /** Deletes; throws (or rejects) when refused. */
  onConfirm: () => Promise<unknown> | void;
}) {
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState<string | undefined>();

  function confirm() {
    setConfirming(false);
    try {
      const deleting = onConfirm();
      if (deleting) deleting.catch((failure: unknown) => setError(userMessage(failure)));
    } catch (refused) {
      setError(userMessage(refused));
    }
  }

  return (
    <div className={`delete-confirmation${confirming ? ' delete-confirmation--open' : ''}`}>
      {confirming ? (
        <div role="group" aria-label={label}>
          <p className="delete-confirmation__warning">{warning}</p>
          <button type="button" className="delete-confirmation__confirm" onClick={confirm}>
            {t('delete.confirm')}
          </button>{' '}
          <button type="button" onClick={() => setConfirming(false)}>
            {t('common.cancel')}
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="delete-confirmation__open"
          onClick={() => {
            setError(undefined);
            setConfirming(true);
          }}
        >
          {label}
        </button>
      )}
      {error && <p role="alert">{error}</p>}
    </div>
  );
}
